import React from 'react';

import { ReactComponent as BoreIcon } from './bore.svg';

function FarmbotBoreIcon() {
  return <BoreIcon width={18} />;
}

export default FarmbotBoreIcon;
